export class SetGradingSchemeToModuleFailure {
    static readonly type = '[GradingScheme] SetGradingSchemeToModuleFailure';
}
